import React, { useCallback } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { OrganizationFileResponse } from '@server/application/files/types/file.types';
import { CellContext } from '@tanstack/react-table';
import { Button } from 'antd';
import { useNotificationContext } from '@/features/notifications';
import { useDeleteFile } from '@/shared/api';
import { useDataInvalidation } from '@/shared/hooks';

export const FileExplorerActionsColumn = <TValue,>({
  row: { original: file },
}: CellContext<OrganizationFileResponse, TValue>) => {
  const invalidate = useDataInvalidation('files');
  const { showNotification } = useNotificationContext();
  const { mutateAsync: deleteFile, isLoading } = useDeleteFile();

  const handleFileDelete = useCallback(async () => {
    try {
      await deleteFile({ pathParams: { fileId: file.id } });
      invalidate();
      showNotification({
        type: 'success',
        message: 'Success',
        description: 'File deleted successfully',
      });
    } catch {
      showNotification({
        type: 'error',
        message: 'Error',
        description: 'Failed to delete file',
      });
    }
  }, [file.id, invalidate, deleteFile, showNotification]);

  return (
    <Button
      danger
      type="text"
      icon={<DeleteOutlined />}
      disabled={isLoading}
      loading={isLoading}
      onClick={handleFileDelete}
    />
  );
};
